import {constants} from '@neosvoc/nv-platform-core-common';

export const ADMIN_USER_LIST_REQUESTED = 'ADMIN_USER_LIST_REQUESTED';
export const ADMIN_USER_LIST_SUCCESS = 'ADMIN_USER_LIST_SUCCESS';
export const ADMIN_USER_LIST_FAILURE = 'ADMIN_USER_LIST_FAILURE';
export const ADMIN_USER_LIST_CHANGE_PAGE = 'ADMIN_USER_LIST_CHANGE_PAGE';
export const ADMIN_USER_CREATE_REQUESTED = 'ADMIN_USER_CREATE_REQUESTED';
export const ADMIN_USER_EDIT_REQUESTED = 'ADMIN_USER_EDIT_REQUESTED';
export const ADMIN_USER_REQUESTED = 'ADMIN_USER_REQUESTED';
export const ADMIN_USER_SUCCESS = 'ADMIN_USER_SUCCESS';
export const ADMIN_USER_FAILURE = 'ADMIN_USER_FAILURE';
export const ADMIN_USER_LIST_CHANGE_FILTER = 'ADMIN_USER_LIST_CHANGE_FILTER';

export const ADMIN_ORGANIZATION_LIST_REQUESTED = 'ADMIN_ORGANIZATION_LIST_REQUESTED';
export const ADMIN_ORGANIZATION_LIST_SUCCESS = 'ADMIN_ORGANIZATION_LIST_SUCCESS';
export const ADMIN_ORGANIZATION_LIST_FAILURE = 'ADMIN_ORGANIZATION_LIST_FAILURE';

export const AUTH_LOGIN_REQUESTED = 'AUTH_LOGIN_REQUESTED';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_USER_REQUESTED = 'AUTH_USER_REQUESTED';
export const AUTH_IMPERSONATE_REQUESTED = 'AUTH_IMPERSONATE_REQUESTED';
export const AUTH_IMPERSONATE_SUCCESS = 'AUTH_IMPERSONATE_SUCCESS';
export const AUTH_IMPERSONATE_FAILURE = 'AUTH_IMPERSONATE_FAILURE';

export const SURVEY_LIST_REQUESTED = 'SURVEY_LIST_REQUESTED';
export const SURVEY_LIST_SUCCESS = 'SURVEY_LIST_SUCCESS';
export const SURVEY_LIST_FAILURE = 'SURVEY_LIST_FAILURE';
export const SURVEY_LIST_CHANGE_PAGE = 'SURVEY_LIST_CHANGE_PAGE';
export const SURVEY_LIST_CHANGE_FILTER = 'SURVEY_LIST_CHANGE_FILTER';

export const MEDIA_LIST_REQUESTED = 'MEDIA_LIST_REQUESTED';
export const MEDIA_LIST_SUCCESS = 'MEDIA_LIST_SUCCESS';
export const MEDIA_LIST_FAILURE = 'MEDIA_LIST_FAILURE';
export const MEDIA_LIST_CHANGE_PAGE = 'MEDIA_LIST_CHANGE_PAGE';
export const MEDIA_LIST_CHANGE_FILTER = 'MEDIA_LIST_CHANGE_FILTER';
export const MEDIA_UPLOAD_REQUESTED = 'MEDIA_UPLOAD_REQUESTED';
export const MEDIA_UPLOAD_SUCCESS = 'MEDIA_UPLOAD_SUCCESS';
export const MEDIA_UPLOAD_FAILURE = 'MEDIA_UPLOAD_FAILURE';
export const MEDIA_DELETE_REQUESTED = 'MEDIA_DELETE_REQUESTED';
export const MEDIA_DELETE_SUCCESS = 'MEDIA_DELETE_SUCCESS';
export const MEDIA_DELETE_FAILURE = 'MEDIA_DELETE_FAILURE';

export const SURVEY_TRACKERS_REQUESTED = 'SURVEY_TRACKERS_REQUESTED';
export const SURVEY_TRACKERS_SUCCESS = 'SURVEY_TRACKERS_SUCCESS';
export const SURVEY_TRACKERS_FAILURE = 'SURVEY_TRACKERS_FAILURE';
export const SURVEY_TRACKERS_SEND_REQUESTED = 'SURVEY_TRACKERS_SEND_REQUESTED';
export const SURVEY_TRACKERS_SEND_SUCCESS = 'SURVEY_TRACKERS_SEND_SUCCESS';
export const SURVEY_TRACKERS_SEND_FAILURE = 'SURVEY_TRACKERS_SEND_FAILURE';
export const SURVEY_TRACKERS_DELETE_REQUESTED = 'SURVEY_TRACKERS_DELETE_REQUESTED';
export const SURVEY_TRACKERS_DELETE_SUCCESS = 'SURVEY_TRACKERS_DELETE_SUCCESS';
export const SURVEY_TRACKERS_DELETE_FAILURE = 'SURVEY_TRACKERS_DELETE_FAILURE';
export const SURVEY_TRACKERS_SAVE_REQUESTED = 'SURVEY_TRACKERS_SAVE_REQUESTED';
export const SURVEY_TRACKERS_SAVE_SUCCESS = 'SURVEY_TRACKERS_SAVE_SUCCESS';
export const SURVEY_TRACKERS_SAVE_FAILURE = 'SURVEY_TRACKERS_SAVE_FAILURE';
export const SURVEY_TRACKERS_TEST_REQUESTED = 'SURVEY_TRACKERS_TEST_REQUESTED';
export const SURVEY_TRACKERS_TEST_SUCCESS = 'SURVEY_TRACKERS_TEST_SUCCESS';
export const SURVEY_TRACKERS_TEST_FAILURE = 'SURVEY_TRACKERS_TEST_FAILURE';
export const SURVEY_TRACKERS_ARCHIVE_UPDATE_REQUESTED = 'SURVEY_TRACKERS_ARCHIVE_UPDATE_REQUESTED';
export const SURVEY_TRACKERS_ARCHIVE_UPDATE_SUCCESS = 'SURVEY_TRACKERS_ARCHIVE_UPDATE_SUCCESS';
export const SURVEY_TRACKERS_ARCHIVE_UPDATE_FAILURE = 'SURVEY_TRACKERS_ARCHIVE_UPDATE_FAILURE';
export const SURVEY_WAVE_TRACKERS_DELETE_REQUESTED = 'SURVEY_WAVE_TRACKERS_DELETE_REQUESTED';
export const SURVEY_WAVE_TRACKERS_DELETE_SUCCESS = 'SURVEY_WAVE_TRACKERS_DELETE_SUCCESS';
export const SURVEY_WAVE_TRACKERS_DELETE_FAILURE = 'SURVEY_WAVE_TRACKERS_DELETE_FAILURE';

export const SURVEY_REQUESTED = 'SURVEY_REQUESTED';
export const SURVEY_UNLOAD = 'SURVEY_UNLOAD';
export const SURVEY_EDIT_REQUESTED = 'SURVEY_EDIT_REQUESTED';
export const SURVEY_CREATE_REQUESTED = 'SURVEY_CREATE_REQUESTED';
export const SURVEY_SUCCESS = 'SURVEY_SUCCESS';
export const SURVEY_FAILURE = 'SURVEY_FAILURE';
export const SURVEY_DELETE_REQUESTED = 'SURVEY_DELETE_REQUESTED';
export const SURVEY_DELETE_SUCCESS = 'SURVEY_DELETE_SUCCESS';
export const SURVEY_DELETE_FAILURE = 'SURVEY_DELETE_FAILURE';
export const SURVEY_DELETE_INSTANCES_REQUESTED = 'SURVEY_DELETE_INSTANCES_REQUESTED';
export const SURVEY_DELETE_INSTANCES_SUCCESS = 'SURVEY_DELETE_INSTANCES_SUCCESS';
export const SURVEY_DELETE_INSTANCES_FAILURE = 'SURVEY_DELETE_INSTANCES_FAILURE';
export const SURVEY_EXPORT_REQUESTED = 'SURVEY_EXPORT_REQUESTED';
export const SURVEY_EXPORT_SUCCESS = 'SURVEY_EXPORT_SUCCESS';
export const SURVEY_EXPORT_FAILURE = 'SURVEY_EXPORT_FAILURE';
export const SURVEY_EXPORT_COMPLETE = 'SURVEY_EXPORT_COMPLETE';

export const SURVEY_DETAIL_REQUESTED = 'SURVEY_DETAIL_REQUESTED';
export const SURVEY_DETAIL_UNLOAD = 'SURVEY_DETAIL_UNLOAD';
export const SURVEY_DETAIL_SUCCESS = 'SURVEY_DETAIL_SUCCESS';
export const SURVEY_DETAIL_FAILURE = 'SURVEY_DETAIL_FAILURE';

export const ANALYTICS_REQUESTED = 'ANALYTICS_REQUESTED';
export const ANALYTICS_SUCCESS = 'ANALYTICS_SUCCESS';
export const ANALYTICS_FAILURE = 'ANALYTICS_FAILURE';
export const ANALYTICS_LOADING = 'ANALYTICS_LOADING';
export const ANALYTICS_BATCH_REQUESTED = 'ANALYTICS_BATCH_REQUESTED';
export const BATCH_ANALYTICS_SIZE = 12;

export const BATCH_EXCLUDED_WIDGET_TYPES = [
    constants.WIDGET_TYPES.CHANNEL_STATS,
    constants.WIDGET_TYPES.SURVEY_STATS,
    constants.WIDGET_TYPES.SURVEY_SENT_STATS,
    constants.WIDGET_TYPES.INSTANCE_COMPLETED_AT,
];

export const DASHBOARD_REQUESTED = 'DASHBOARD_REQUESTED';
export const DASHBOARD_SUCCESS = 'DASHBOARD_SUCCESS';
export const DASHBOARD_FAILURE = 'DASHBOARD_FAILURE';
export const DASHBOARD_EXPORT_REQUESTED = 'DASHBOARD_EXPORT_REQUESTED';
export const DASHBOARD_EXPORT_SUCCESS = 'DASHBOARD_EXPORT_SUCCESS';
export const DASHBOARD_EXPORT_FAILURE = 'DASHBOARD_EXPORT_FAILURE';
export const DASHBOARD_EXPORT_COMPLETE = 'DASHBOARD_EXPORT_COMPLETE';

export const ORGANIZATION_REQUESTED = 'ORGANIZATION_REQUESTED';
export const ORGANIZATION_SUCCESS = 'ORGANIZATION_SUCCESS';
export const ORGANIZATION_FAILURE = 'ORGANIZATION_FAILURE';
export const ORGANIZATION_EDIT_REQUESTED = 'ORGANIZATION_EDIT_REQUESTED';

export const SURVEY_WAVE_CREATE_SUCCESS = 'SURVEY_WAVE_CREATE_SUCCESS';
export const SURVEY_WAVE_EDIT_SUCCESS = 'SURVEY_WAVE_EDIT_SUCCESS';
export const SURVEY_WAVE_DELETE_SUCCESS = 'SURVEY_WAVE_DELETE_SUCCESS';

export const SURVEY_TAGS_REQUESTED = 'SURVEY_TAGS_REQUESTED';
export const SURVEY_TAGS_SUCCESS = 'SURVEY_TAGS_SUCCESS';
export const SURVEY_TAGS_FAILURE = 'SURVEY_TAGS_FAILURE';

export const SETTINGS_CHANGE_LANGUAGE = 'SETTINGS_CHANGE_LANGUAGE';

export const LOGIC_OP_AND = 'and';
export const LOGIC_OP_OR = 'or';

export const AVAILABLE_TYPES = [
    constants.EDITOR_TEMPLATES.STRING_1,
    constants.EDITOR_TEMPLATES.TEXT_1,
    constants.EDITOR_TEMPLATES.NUMBER_1,
    constants.EDITOR_TEMPLATES.NUMBER_2,
    constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_1,
    constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2,
    constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_3,
    constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1,
    constants.EDITOR_TEMPLATES.SINGLE_CHOICE_2,
    constants.EDITOR_TEMPLATES.SINGLE_CHOICE_3,
    constants.EDITOR_TEMPLATES.SINGLE_CHOICE_4,
    constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1,
    constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_2,
    constants.EDITOR_TEMPLATES.RANK_1,
    constants.EDITOR_TEMPLATES.BATTERY_1,
    constants.EDITOR_TEMPLATES.BATTERY_2,
    constants.EDITOR_TEMPLATES.DATE_1,
    constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1_EXT,
    constants.EDITOR_TEMPLATES.IMAGE_1,
    // constants.EDITOR_TEMPLATES.GEO_1,
    // constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER,
    constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2,
];

export const AVAILABLE_TYPES_TREE = [
    {
        id: 1,
        name: 'text_variables',
        icon: constants.EDITOR_TEMPLATES.TEXT_1,
        types: [
            constants.EDITOR_TEMPLATES.STRING_1,
            constants.EDITOR_TEMPLATES.TEXT_1,
        ],
    },
    {
        id: 2,
        name: 'battery_variables',
        icon: constants.EDITOR_TEMPLATES.BATTERY_1,
        types: [
            constants.EDITOR_TEMPLATES.BATTERY_1,
            constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2,
            constants.EDITOR_TEMPLATES.BATTERY_2,
        ],
    },
    {
        id: 3,
        name: 'scale_variables',
        icon: constants.EDITOR_TEMPLATES.NUMBER_2,
        types: [
            constants.EDITOR_TEMPLATES.NUMBER_2,
            constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_1,
            constants.EDITOR_TEMPLATES.SINGLE_CHOICE_3,
            constants.EDITOR_TEMPLATES.RANK_1,
        ],
    },
    {
        id: 4,
        name: 'categorical_variables',
        icon: constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1,
        types: [
            constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1,
            constants.EDITOR_TEMPLATES.SINGLE_CHOICE_2,
            constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1,
            constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1_EXT,
        ],
    },
    {
        id: 5,
        name: 'image_variables',
        icon: constants.EDITOR_TEMPLATES.IMAGE_1,
        types: [
            constants.EDITOR_TEMPLATES.SINGLE_CHOICE_4,
            constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_2,
            constants.EDITOR_TEMPLATES.IMAGE_1,
        ],
    },
    {
        id: 6,
        name: 'rating_variables',
        icon: constants.EDITOR_TEMPLATES.RATING_1,
        types: [
            constants.EDITOR_TEMPLATES.NUMBER_3,
            constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_4,
        ],
    },
    {
        id: 7,
        name: 'other_variables',
        icon: constants.EDITOR_TEMPLATES.NUMBER_1,
        types: [
            constants.EDITOR_TEMPLATES.DATE_1,
            constants.EDITOR_TEMPLATES.NUMBER_1,
            // constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER,
            constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_3,
            constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2,
        ],
    },
];

export const TRACKER_FILTERS = {
    ALL: 'all',
    NOT_STARTED: 'not_started',
    NOT_COMPLETED: 'not_completed',
};

export const TRACKERS_PAGE_SIZE = 20;

export const TRACKERS_ARCHIVE_OPTIONS = {
    NEVER: 'never',
    TRACKER_CREATED: 'trackerCreated',
    WAVE_EXPIRED: 'waveExpired',
};


export const INSTANCE_FILTERS = {
    COMPLETED: 'completed',
    ALL: 'all',
    NOT_COMPLETED: 'not_completed',
};

export const PRINTABLE_WIDGETS = {
    // [constants.WIDGET_TYPES.CHANNEL_STATS]: false,
    [constants.WIDGET_TYPES.CHANNEL_STATS]: {},
    [constants.WIDGET_TYPES.GENERATOR_ENTITY_EXTRACTION]: {},
    [constants.WIDGET_TYPES.GENERATOR_NPS]: {},
    [constants.WIDGET_TYPES.GENERATOR_SENTIMENT_ANALYSIS]: {},
    [constants.WIDGET_TYPES.GEO]: {},
    [constants.WIDGET_TYPES.INSTANCE_COMPLETED_AT]: {},
    [constants.WIDGET_TYPES.MULTIPLE_CHOICE]: {},
    [constants.WIDGET_TYPES.NUMBER]: {},
    [constants.WIDGET_TYPES.SINGLE_CHOICE]: {},
    [constants.WIDGET_TYPES.SINGLE_CHOICE_BATTERY]: {},
    [constants.WIDGET_TYPES.MULTIPLE_CHOICE_BATTERY]: {},
    [constants.WIDGET_TYPES.SURVEY_STATS]: false,
    [constants.WIDGET_TYPES.SURVEY_SENT_STATS]: false,
    // [constants.WIDGET_TYPES.SURVEY_STATS]: {},
    // [constants.WIDGET_TYPES.SURVEY_SENT_STATS]: {},
    [constants.WIDGET_TYPES.MULTIPLE_NUMBER3_BATTERY]: {},
    [constants.WIDGET_TYPES.RANK]: {},
};

export const MULTIPLE_NUMBER_1_PRESETS = [
    {id: 1, name: 'Min: 1, Max: 5, Step: 1', min: 1, max: 5, step: 1},
    {id: 2, name: 'Min: 1, Max: 7, Step: 1', min: 1, max: 7, step: 1},
    {id: 3, name: 'Min: -3, Max: 3, Step: 1', min: -3, max: 3, step: 1},
    {id: 4, name: 'Min: -10, Max: 10, Step: 1', min: -10, max: 10, step: 1},
];

export const IMAGE_RATIO_FORMATS = [
    {id: 0, name: 'No'},
    {id: 1, name: '1:1'},
    {id: 2, name: '4:3'},
    {id: 3, name: '16:9'},
    {id: 4, name: '3:4'},
    {id: 5, name: '9:16'},
];

export const SEND_PROVIDERS = {
    NONE: '',
    MAPP: 'mapp',
    PINPOINT: 'pinpoint',
    AWS: 'aws',
};

export const fontLabels = [
    {key: constants.BRANDING_FONTS.WORK_SANS, label: 'Work Sans'},
    {key: constants.BRANDING_FONTS.ROBOTO, label: 'Roboto'},
    {key: constants.BRANDING_FONTS.OSWALD, label: 'Oswald'},
    {key: constants.BRANDING_FONTS.LORA, label: 'Lora'},
    {key: constants.BRANDING_FONTS.LOBSTER_TWO, label: 'Lobster Two'},
    {key: constants.BRANDING_FONTS.KALAM, label: 'Kalam'},
    {key: constants.BRANDING_FONTS.ALBERT, label: 'Albert'},
];

export const availableFonts = Object.values(constants.BRANDING_FONTS);

export const colorRegex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;
